(function () {
  const initProductAccordion = () => {
    $(".product-about__accordion-title").click(function (e) {
      // Prevent default behavior that might cause scrolling
      e.preventDefault();
      
      const $this = $(this);
      const $description = $this.next(".product-about__accordion-description");
      
      // Capturar a posição de scroll atual imediatamente
      const initialScrollTop = $(window).scrollTop();
      
      if (!$this.hasClass("active")) {
        // Fechar qualquer item aberto primeiro
        $(".product-about__accordion-title.active").removeClass("active");
        $(".product-about__accordion-description").stop().slideUp(300);
        
        // Abrir o item clicado
        $this.addClass("active");
        
        // IMPORTANTE: Fixar o scroll na posição atual durante toda a animação
        // para evitar qualquer scroll para baixo
        const scrollInterval = setInterval(function() {
          $(window).scrollTop(initialScrollTop);
        }, 10);
        
        $description.stop().slideDown(10, function() {
          // Parar o intervalo de fixação de scroll
          clearInterval(scrollInterval);
          
          // Encontrar o primeiro product-about
          const $firstProductAbout = $('.product-about').first();
          const targetTop = $firstProductAbout.offset().top - 120;
          
          // Só rolar para cima (nunca para baixo)
          if (targetTop < initialScrollTop) {
            $('html, body').animate({
              scrollTop: targetTop
            }, 200);
          } else {
            // Garantir que estamos na posição original
            $(window).scrollTop(initialScrollTop);
          }
        });
      } else {
        // Se clicar em um item já ativo, apenas fechá-lo
        $this.removeClass("active");
        $description.stop().slideUp(10);
      }
    });
  };
  
  // Inicializar na carga da página
  initProductAccordion();
  
  // Reinicializar quando as seções do Shopify carregarem
  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
  });
})();